import { get } from 'scriptjs';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
@Component({
  selector: 'app-askforbanknumber',
  templateUrl: './askforbanknumber.component.html',
  styleUrls: ['./askforbanknumber.component.css']
})
export class AskforbanknumberComponent implements OnInit , OnDestroy {

  Formfmdata:UntypedFormGroup;
  constructor(private spinner:NgxSpinnerService) {
    this.LoadZone();
    this.Formfmdata = new UntypedFormGroup({
      selectzone:new UntypedFormControl('00'),
      fmname:new UntypedFormControl(''),
      fmcode:new UntypedFormControl(''),
    })
   }

  ngOnInit(): void {
  }

  // โหลดข้อมูล zone
  zonecode:any;
  LoadZone(){
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url)
    .then(res =>{
      this.zonecode = (res.data.recordset);
      this.spinner.hide();
    }).catch(err => { throw(err)})
    this.spinner.hide();
  }


  // โหลดชาวไร่ในโซน
  databyzone:any;
  @ViewChild('fmtable', {static:false}) fmtable:any;
  Loadbyzone(){
    let zone = this.Formfmdata.get('selectzone').value;
    this.databyzone = null;
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_farmerforbbl_w?SUPZONE="+zone;
    axios.get(url)
    .then(res =>{
      this.databyzone = (res.data.recordset);
      setTimeout(() => {
        $(this.fmtable.nativeElement).DataTable();
      }, 1500);
      this.spinner.hide();
    }).catch(err => { throw(err)})
    this.spinner.hide();
  }

  //  เลือก 1 รายการ
  choseone:any;
  Oneselect(id:any){
   this.choseone =  this.databyzone.filter((el:any) => el.FMCODE == id);
   this.Formfmdata.get('fmname').setValue(String(this.choseone[0].fmname));
   this.Formfmdata.get('fmcode').setValue(String(this.choseone[0].FMCODE));
  }

  // ขอรหัสใหม่
  Addnewcode(fmcode:any,zone:any){
    if(confirm('ยืนยันการขอโควตาใหม่ ?')==true){
      this.spinner.show();
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_quotaid?Fmcode="+fmcode.trim()+"&supzone=" + zone;
      axios.post(url)
      .then(res =>{
         if(res.data.rowsAffected[0]==1){
           alert('เพิ่มโควตาใหม่แล้วค่ะ^^!')
           this.Loadbyzone();
         }
         else {
          alert('!!! ทำรายการไม่สำเร็จกรุณาลองใหม่ !!! ')
         }
       
        this.spinner.hide();
      }).catch(err => { throw(err)})
      this.spinner.hide();
    }
    else {}
  }

  
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.databyzone = null;
    this.zonecode = null;
  }

}

